import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectLanguagesData } from "../../../redux/selectors/languageSelectors";
import { formatLanguageName } from "../../../lib/utils";
import "./languages-banner.css";

function LanguagesBanner() {
  const languages = useSelector(selectLanguagesData);
  const displayLanguages = useMemo(() => {
    const names = languages
      .map((lang) => formatLanguageName(lang.name))
      .filter(Boolean);
    const unique = Array.from(new Set(names));
    return unique.length ? unique : ["Fulfulde", "Yoruba", "Nufi", "Basaa"];
  }, [languages]);

  return (
    <div className="polyglot-languages-banner">
      <div className="polyglot-languages-track" aria-hidden="true">
        {displayLanguages.map((name) => (
          <span key={`a-${name}`} className="polyglot-language-pill">
            {name}
          </span>
        ))}
        {displayLanguages.map((name) => (
          <span key={`b-${name}`} className="polyglot-language-pill">
            {name}
          </span>
        ))}
      </div>
    </div>
  );
}

export default LanguagesBanner;
